module.exports = __webpack_public_path__ + "static/media/WaterDeficitCalc-thumbnail.eccb9df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/WaterDeficitCalc-thumbnail.png
// module id = 1221
// module chunks = 0